const scrollTop = () => {
  setTimeout(() => {
    const root = document.getElementById('root');
    root?.scrollIntoView();
  }, 0);
};
export default scrollTop;
